export default __webpack_public_path__ + "static/frame-6408119ea69506f0994e65bc1efb4daa.png";